export default {
  data() {
    return {
      allDataModal: {},
      calculationValues: {},
      form: {},
      result: null,
      errors: {},
      errorMessage: null,
      loadingResult: false,
      noResultsFound: false,
      notSearchedYes: true,
      loadingSaving: false,
      resultSaved: false,
      lastSavedResult: false,
    };
  },
  methods: {

  },
};
